
import { BaseModuleMobileApi } from "../../base/BaseModuleMobileApi";

export class MobileWorkspacesApi extends BaseModuleMobileApi {
  basePath = 'workspaces';


  async getAvailableWorkspacesTypesList(offset: number, limit: number, headers: any, filters: any, orderby: any, configOptions?: any, params?: any,) {
    const response = await this.axiosInstance!.get(`/mobile/${this.basePath}_types`, { params: { offset, limit, ...orderby, ...filters, ...params }, headers: null, ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };
};
